// src/components/table/columns/userColumns.tsx
import {ColumnDef} from '@tanstack/react-table';
import {Box, Chip, Stack, Typography} from '@mui/material';
import {Send, Trash} from 'iconsax-react';
import {UserListingResponseModel} from 'models/tenant.model';
import {AppCheckbox} from 'components/form';
import {AppMenu} from 'components/menus';

interface UserColumnsRelationsProps {
    selectedIds: string[];
    isAllSelected: boolean;
    handleSelectAll: (checked: boolean, ids: string[]) => void;
    handleEmailInvite: (value: string) => void;
    handleRowSelect: (checked: boolean, id: string) => void;
    setIsDeleteAlertOpen: (val: boolean, id?: string) => void;
}

export const userColumnsRelations = ({
    selectedIds,
    isAllSelected,
    handleSelectAll,
    handleRowSelect,
    handleEmailInvite,
    setIsDeleteAlertOpen,
}: UserColumnsRelationsProps): ColumnDef<UserListingResponseModel>[] => [
    {
        header: ({table}) => (
            <AppCheckbox
                label=""
                checked={isAllSelected}
                onChange={e =>
                    handleSelectAll(
                        e.target.checked,
                        table.getPrePaginationRowModel().rows.map(row => row.original.id),
                    )
                }
            />
        ),
        accessorKey: 'id',
        cell: ({row}) => (
            <AppCheckbox
                label=""
                checked={selectedIds.includes(row.original.id)}
                onChange={e => handleRowSelect(e.target.checked, row.original.id)}
            />
        ),
        enableSorting: false,
        enableColumnFilter: false,
    },
    {
        header: 'First Name',
        id: 'name',
        accessorKey: 'firstName',
        enableSorting: false,
        cell: ({getValue}) => (
            <Stack direction="row" spacing={1.5} alignItems="center">
                <Typography variant="body1">{getValue() as string}</Typography>
            </Stack>
        ),
    },
    {
        header: 'Last Name',
        accessorKey: 'lastName',
        enableSorting: false,
        cell: ({getValue}) => (
            <Stack direction="row" spacing={1.5} alignItems="center">
                <Typography variant="body1">{getValue() as string}</Typography>
            </Stack>
        ),
    },
    {
        header: 'Email',
        accessorKey: 'email',
        enableSorting: false,
        cell: ({getValue}) => (
            <Stack direction="row" spacing={1.5} alignItems="center">
                <Typography variant="body1">{getValue() as string}</Typography>
            </Stack>
        ),
    },
    {
        header: 'Status',
        accessorKey: 'status',
        enableSorting: false,
        cell: ({getValue}) => (
            <Stack direction="row" spacing={1.5} alignItems="center">
                <Chip
                    label={getValue() as string}
                    color={getValue() === 'Accepted' ? 'success' : 'primary'}
                    variant="outlined"
                />
            </Stack>
        ),
    },
    {
        header: 'Actions',
        enableSorting: false,
        cell: ({row}) => (
            <Stack direction="row" spacing={1.5} alignItems="center">
                <AppMenu
                    menuItems={[
                        {
                            label: 'Remove',
                            icon: (
                                <Box mt={1}>
                                    <Trash color="red" variant="Bold" size="16px" />
                                </Box>
                            ),
                            onClick: () => {
                                setIsDeleteAlertOpen(true, row.original.id);
                            },
                        },
                        ...(row.original.status !== 'Accepted'
                            ? [
                                  {
                                      label: 'Send Invite',
                                      icon: (
                                          <Box mt={1}>
                                              <Send color="blue" variant="Bold" size="16px" />
                                          </Box>
                                      ),
                                      onClick: () => handleEmailInvite(row.original.email),
                                  },
                              ]
                            : []),
                    ]}
                />
            </Stack>
        ),
    },
];
